// @flow
import {
	MenuItem,
	InputAdornment,
	TextField,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import type { selectType } from '@shared/model/components';
import { useState } from 'react';
import findNestedValue from '@shared/utils/findNestedValue';
import HelperText from '@shared/components/helperText';

function Select({
	label,
	name,
	control,
	errors,
	schema,
	items,
	defaultValue,
	comment,
	variant = 'outlined',
	startIcon,
	endIcon,
	...selectProps
}: selectType): React$Node {

	const [isRequired] = useState(
		schema?.describe()?.fields[name]?.tests?.some((test) => test.name === 'required') || false,
	);

	return (
		<Controller
			name={name}
			defaultValue={defaultValue || items[0]?.value}
			control={control}
			render={({ field }) => {
				const foundError = findNestedValue(errors, name);
				return (
					<TextField
						sx={{ '& .MuiInputBase-root': (selectProps.multiple && Array.isArray(field.value) && field.value.length>0) && { height: 'unset' } }}
						label={label}
						select
						variant={variant}
						fullWidth
						{...field}
						required={isRequired}
						error={Boolean(foundError)}
						helperText={<HelperText message={foundError?.message || comment}/>}
						InputProps={{
							endAdornment: endIcon && (
								<InputAdornment position={'end'}>{endIcon}</InputAdornment>
							),
							startAdornment: startIcon && (
								<InputAdornment position={'start'}>{startIcon}</InputAdornment>
							),
						}}
						SelectProps={{ ...selectProps }}
					>
						{
							items.map((item) => {
								const { value, title, id, ...props } = item;
								return (
									<MenuItem
										{...props}
										key={id}
										value={value}
										id={`item-${value}`}
									>
										{title}
									</MenuItem>
								);
							})
						}
					</TextField>
				);
			}}
		/>
	);
}

export default Select;
